// extracted by mini-css-extract-plugin
export var wrapper = "QuestionsSection-module--wrapper--JCe+X";